var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "work-template",
    {
      class: "" + _vm.className,
      attrs: { project: _vm.project, events: _vm.events }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "slides" },
        _vm._l(_vm.project_images, function(image, index) {
          return _c("div", { key: index, staticClass: "carousel-cell" }, [
            _c("img", { attrs: { src: image, alt: "" } })
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("template", { slot: "main-content" }, [
        _c("p", [
          _vm._v(
            "\n      A web browser game made with HMTL5 Canvas. It's an arcade style top down horde survival game. I wrote it with Javascript as a final project for my Rich Media & Web App Dev class. I learned many lessons trying to code this as it became very hard to manage by the end. Seperation of concerns, state management, rudimentary ai in games, game loops, closures, the importance of pure and impure functions, and most importantly consideration of the information architecture and organization that facilitates maintenance and the addition of future features.\n    "
          )
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "split" }, [
          _c("div", [
            _c("h2", [_vm._v("Gameplay")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          The player has to survive the horde of monsters as long as possible, there's no end game, the player will die. A horde counter goes up while a horde timer counts down. At each counter interval a new wave of monsters spawn from the perimeter of the arena and attack the player in various ways. The player must move around the arena avoiding and killing the monsters to survive as long as possible. There are 5 types of monsters: grunts, rushers, archers, sorcerers, and tanks. All have different attributes providing an array of attacks to challenge the player. When theplayer dies, there is a high score listing, however it uses local storage so those will only be cached in the browser.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gif" }, [
            _c("img", { attrs: { src: _vm.gameplay_gif, alt: "" } })
          ])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "links-list" }, [
          _c("li", [
            _c("h2", [_vm._v("Proof of Concept")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            An earlier version of the game created a proof of concept to demonstrate core mechanics and gameplay. It has all of the main controls and some combat features that didn't make it to the final game. This is a barebones demo with no assets so you can really see how it functions under the hood.\n          "
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link-btn",
                attrs: { target: "_blank", href: _vm.links.github1 }
              },
              [_vm._v("GitHub")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("h2", [_vm._v("GitHub Project")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            For more information on the controls, gameplay, and features visit the project page on GitHub.\n          "
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link-btn",
                attrs: { target: "_blank", href: _vm.links.github2 }
              },
              [_vm._v("Combo Smash")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "show-desktop" }, [
            _c("h2", [_vm._v("Play the Game")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            (WARNING: This game does not work on mobile or tablet. Requires pointer device and keyboard)\n          "
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link-btn",
                attrs: { target: "_blank", href: _vm.links.demo2 }
              },
              [_vm._v("Play ComboSmash")]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }